export const NO_LABLE_ARRAY = "no_lable_array";
export const GITHUB_ACCESS_TOKEN = "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"
